
import React from "react";
import ASRGoTInterface from "@/pages/ASRGoTInterface";

const Index = () => {
  return <ASRGoTInterface />;
};

export default Index;
